import { render, staticRenderFns } from "./LottieGettingStarted.vue?vue&type=template&id=10b15a6a&"
import script from "./LottieGettingStarted.vue?vue&type=script&lang=js&"
export * from "./LottieGettingStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeBenefits: require('/opt/render/project/src/channels2022/src/components/home-page/HomeBenefits.vue').default})
